module.exports = __webpack_public_path__ + "img/taiyo3s.4f78a453.gif";